// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Dj-1","left":"styles_left__3uLyd","desktopActions":"styles_desktopActions__1jEhF","title":"styles_title__1hpCZ"};